import { useCatalogFetchers } from "@/shared/catalogs/hooks/useCatalogs";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
	setListAllParts: Function;
};

export const useSearchParts = ({
	setIsLoading,
	setError,
	setListAllParts,
}: Props) => {
	const { fetchPartsInventory } = useCatalogFetchers();

	return async () => {
		setIsLoading(true);
		try {
			setListAllParts(await fetchPartsInventory());
		} catch (e: any) {
			setError(e?.message || "Error fetching the parts inventory");
		} finally {
			setIsLoading(false);
		}
	};
};
